var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pos-rel" },
    [
      _c("KSelect", {
        staticClass: "birthyear-select",
        class: { "with-info-icon": _vm.showInfoIcon },
        attrs: {
          value: _vm.selected,
          label: _vm.$attrs.label || _vm.coreString("birthYearLabel"),
          placeholder: _vm.$tr("placeholder"),
          options: _vm.options,
          disabled: _vm.$attrs.disabled,
          clearable: _vm.$attrs.clearable,
          invalid: true,
          invalidText: _vm.$attrs.invalidText,
        },
        on: {
          change: function ($event) {
            return _vm.$emit("update:value", $event.value)
          },
        },
      }),
      _vm.showInfoIcon
        ? _c("CoreInfoIcon", {
            staticClass: "info-icon",
            attrs: {
              tooltipText: _vm.$tr("birthYearTooltip"),
              tooltipPlacement: _vm.tooltipPlacement,
              iconAriaLabel: _vm.$tr("birthyearAriaLabel"),
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }